/**
 * Text-direction helper for the widget.
 *
 * The widget is a standalone TS bundle and cannot import the server-side
 * `QuantumCore.Languages` module. This list MUST stay identical to
 * `apps/quantum_core/lib/quantum_core/languages.ex` `@rtl_languages`.
 */
export const RTL_LANGUAGES = ['ar', 'he', 'fa', 'ur'] as const

/** Normalize a locale tag to its lowercase primary subtag (e.g. "ar-SA" -> "ar"). */
function primarySubtag(locale: string): string {
  return (locale || '').split('-')[0].toLowerCase()
}

/** True when the locale is written right-to-left. */
export function isRtl(locale: string): boolean {
  return (RTL_LANGUAGES as readonly string[]).includes(primarySubtag(locale))
}

/** "rtl" for right-to-left locales, otherwise "ltr". */
export function textDirection(locale: string): 'rtl' | 'ltr' {
  return isRtl(locale) ? 'rtl' : 'ltr'
}

/** Set the `dir` attribute on an element from a locale. */
export function applyTextDirection(el: HTMLElement, locale: string): void {
  el.setAttribute('dir', textDirection(locale))
}
